import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { CampaignList } from '@models/campaign-list';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {
  private readonly baseUrl;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.serverBaseUrl;
  }

  getCampaignsListsByStatus(status): Observable<CampaignList[]> {
    let params = new HttpParams();
    if (status) {
      params = params.append('status', status);
    }
    return (
      this.http
        .get<Response>(this.baseUrl + 'email/list', { params })
        // .get<Response>(this.baseUrl + 'domain', {params})
        .pipe(
          map(data => {
            // const data2 = [
            //   {
            //     idCampaign: 1,
            //     title: 'a'
            //   }, {
            //     idCampaign: 2,
            //     title: 'b'
            //   }];
            return (data as any).map(d => {
              return CampaignList.deserialize(d);
            });
          })
        )
    );
  }
}
